import { t } from 'lib/translations/i18next'
import { BusinessIndustryEnum } from 'gql/types'

export const INDUSTRY_OPTIONS: BusinessIndustryEnum[] = [
  BusinessIndustryEnum.CLOTHING_APPAREL,
  BusinessIndustryEnum.BABY_KIDS,
  BusinessIndustryEnum.ACCESSORIES,
  BusinessIndustryEnum.BEAUTY,
  BusinessIndustryEnum.ELECTRONICS,
  BusinessIndustryEnum.FURNITURE,
  BusinessIndustryEnum.FOOD_BEVERAGE,
  BusinessIndustryEnum.HEALTH_WELLNESS,
  BusinessIndustryEnum.HOME_KITCHEN,
  BusinessIndustryEnum.PET_PRODUCTS,
  BusinessIndustryEnum.TOYS,
  BusinessIndustryEnum.SPORTS,
  BusinessIndustryEnum.ACCOUNTING,
  BusinessIndustryEnum.MARKETING,
  BusinessIndustryEnum.VIRTUAL_SERVICES,
  BusinessIndustryEnum.RESTAURANT_HOSPITALITY,
  BusinessIndustryEnum.LAW_OFFICES,
  BusinessIndustryEnum.CONSTRUCTION,
  BusinessIndustryEnum.REAL_ESTATE,
  BusinessIndustryEnum.OTHER,
]

export const getIndustryLabel = (industry: BusinessIndustryEnum) => {
  switch (industry) {
    case BusinessIndustryEnum.CLOTHING_APPAREL:
      return t('industry::clothingApparel')
    case BusinessIndustryEnum.BABY_KIDS:
      return t('industry::babyKids')
    case BusinessIndustryEnum.ACCESSORIES:
      return t('industry::accessories')
    case BusinessIndustryEnum.BEAUTY:
      return t('industry::beauty')
    case BusinessIndustryEnum.ELECTRONICS:
      return t('industry::electronics')
    case BusinessIndustryEnum.FURNITURE:
      return t('industry::furniture')
    case BusinessIndustryEnum.FOOD_BEVERAGE:
      return t('industry::foodBeverage')
    case BusinessIndustryEnum.HEALTH_WELLNESS:
      return t('industry::healthWellness')
    case BusinessIndustryEnum.HOME_KITCHEN:
      return t('industry::homeKitchen')
    case BusinessIndustryEnum.PET_PRODUCTS:
      return t('industry::petProducts')
    case BusinessIndustryEnum.TOYS:
      return t('industry::toys')
    case BusinessIndustryEnum.SPORTS:
      return t('industry::sports')
    case BusinessIndustryEnum.ACCOUNTING:
      return t('industry::accounting')
    case BusinessIndustryEnum.MARKETING:
      return t('industry::marketing')
    case BusinessIndustryEnum.VIRTUAL_SERVICES:
      return t('industry::virtualServices')
    case BusinessIndustryEnum.RESTAURANT_HOSPITALITY:
      return t('industry::restaurantHospitality')
    case BusinessIndustryEnum.LAW_OFFICES:
      return t('industry::lawOffices')
    case BusinessIndustryEnum.CONSTRUCTION:
      return t('industry::construction')
    case BusinessIndustryEnum.REAL_ESTATE:
      return t('industry::realEstate')
    case BusinessIndustryEnum.OTHER:
      return t('industry::other')
    default:
      return null
  }
}
